import { values } from "lodash";
import { UserContactsEditResponse } from "../../proto/UserContactsEdit_pb";
import store from "../../store";
import { updateUser } from "../../store/users/actions";
import BaseHandler from "../BaseHandler";

export default class HandleUserContactsEditResponse extends BaseHandler<UserContactsEditResponse> {
  handle() {
    const userContactsEditResponse = this.response.toObject();
    const userId = values(store.getState().users.users).find((user) => user.phone === userContactsEditResponse.phone)?.id;
    if (userId !== undefined) {
      store.dispatch(
        updateUser({
          userId: userId,
          values: {
            phone: userContactsEditResponse.phone,
            firstName: userContactsEditResponse.firstName,
            lastName: userContactsEditResponse.lastName,
            initials: userContactsEditResponse.initials,
            displayName: userContactsEditResponse.firstName + " " + userContactsEditResponse.lastName,
          },
        })
      );
    }
  }
}
